import type { Quest } from '../types'
import { evaluateQuest } from '../quests'
import type { QuestProgress } from '../quests'
import type { QuestState } from '../questState'
import { isAssigned } from '../questState'

export interface QuestChecklistApi {
  refresh: (quests: Quest[], state: QuestState) => void
  hide: () => void
}

/**
 * Compact on-foot mirror of the active Atlas quest. Atlas remains the journal;
 * this only appears after a quest has been assigned.
 */
export function bindQuestChecklist(): QuestChecklistApi {
  const root = document.querySelector<HTMLElement>('#quest-checklist')
  const title = document.querySelector<HTMLElement>('#qc-title')
  const list = document.querySelector<HTMLElement>('#qc-steps')
  if (!root || !title || !list) {
    return { refresh: () => {}, hide: () => {} }
  }

  const hide = () => {
    root.hidden = true
  }

  const paint = (quest: Quest, progress: QuestProgress) => {
    title.textContent = quest.title
    list.replaceChildren()
    for (const step of progress.steps) {
      const item = document.createElement('li')
      item.className = step.done ? 'qc-done' : 'qc-todo'
      item.textContent = `${step.done ? '✓' : '○'} ${step.text}`
      list.append(item)
    }
    root.hidden = false
  }

  return {
    refresh: (quests, state) => {
      const active =
        quests.find((quest) => isAssigned(state, quest.id) && !evaluateQuest(quest, state).complete) ??
        null
      if (!active) {
        hide()
        return
      }
      paint(active, evaluateQuest(active, state))
    },
    hide,
  }
}
